import { axiosInstance } from '@/lib/axios'

type Props = {
  companyId: string
  ids: (string | number)[]
}

export async function downloadImportedFiles({ companyId, ids }: Props): Promise<void> {
  if (ids.length === 0) return

  const response = await axiosInstance.get(
    `/api/${companyId}/fileProcessing/download`,
    {
      params: { ids: ids.map((id) => Number(id)) },
      // ids=1&ids=2&ids=3 — matches ASP.NET Core int[] binding (axios 0.27 expects a function)
      paramsSerializer: (params: Record<string, unknown>) => {
        const parts: string[] = []
        for (const [key, value] of Object.entries(params)) {
          if (Array.isArray(value)) {
            for (const v of value) parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`)
          } else if (value != null) {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
          }
        }
        return parts.join('&')
      },
      responseType: 'blob',
    },
  )

  const blob = new Blob([response.data], {
    type: response.headers['content-type'] || 'application/octet-stream',
  })

  let filename = ids.length === 1 ? 'file' : `files-${Date.now()}.zip`
  const cd = response.headers['content-disposition']
  if (cd) {
    const match = cd.match(/filename\*?=(?:UTF-8'')?(['"]?)([^'";\n]+)\1/i)
    if (match && match[2]) {
      try {
        filename = decodeURIComponent(match[2])
      } catch {
        filename = match[2]
      }
    }
  }

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
